export default {
    "title": "🇨🇿 Čeština",

    "首页": "Domov",
    "关于": "O nás",
    "会员": "Členství",
    "推荐计划": "Referenční program",
    "个人": "Profil",
    "推荐": "Odkaz",
    "预订": "Rezervujte nyní",
    "事件": "Událost",
    "登出": "Odhlásit se",
    "登录": "Přihlásit se",
    "注册": "Registrovat",
    "我们的应用程序现在可用": "Naše aplikace je nyní k dispozici",
    "为了获得更好的体验，我们刚刚推出了移动应用程序，以实现无缝、更快的预订。": "Pro lepší zážitek jsme právě spustili naše mobilní aplikace pro bezproblémové a rychlejší rezervace.",
    "iOS版下载（即将推出）": "Stáhnout pro iOS (brzy bude k dispozici)",
    "Android版下载（即将推出）": "Stáhnout pro Android (brzy bude k dispozici)",
    "为什么选择我们": "Proč si vybrat nás",
    "我们卓越的服务。": "Naše vynikající služby.",
    "收入最高的酒店": "Nejvyšší příjmy atrakcí",
    "我们的合作酒店收入最高。": "Naše spolupracující atrakce s nejvyššími příjmy.",
    "回报": "Návraty",
    "最具特色的酒店": "Nejvíce vyzdvihované atrakce",
    "我们平台上最有特色的酒店。": "Nejvíce vyzdvihovaný hotel na naší platformě.",
    "热门国家和目的地": "Nejlepší země a destinace",
    "从我们的合作伙伴和朋友那里了解一些来自城市各地的最佳提示。": "Objevte nejlepší tipy z města od našich partnerů a přátel.",
    "酒店": "Atrakcí",
    "预订酒店并开始赚取": "Prozkoumejte svět s námi!",
    "让我们开始与TitanTraveler一起探索世界": "Připravte se na objevování světa atrakcí s námi!",
    "客户评价": "Reference",
    "查看我们用户的真实评价。": "Zkontrolujte naše autentické reference od našich uživatelů.",
    "银行卡列表": "Seznam bankovních karet",
    "银行列表": "Seznam bank",
    "持卡人姓名": "Jméno držitele karty",
    "银行卡号": "Číslo bankovního účtu (IBAN)",
    "支付密码": "Platební heslo",
    "提交": "Odeslat",
    "Pix列表": "Seznam Pix",
    "Pix类型": "Typ Pix",
    "Pix账号": "Účet Pix",
    "账号列表": "Seznam účtů",
    "网络": "Síť",
    "地址": "Adresa",
    "备注": "Poznámka",
    "充值金额": "Částka dobíjení",
    "支付类型": "Typ platby",
    "支付银行": "Platba bankou",
    "USDT地址": "Adresa USD",
    "二维码": "QR kód",
    "充值渠道": "Kanál dobíjení",
    "充值凭证": "Doklad o dobíjení",
    "立即登录": "Přihlásit se nyní",
    "用户名": "Uživatelské jméno",
    "密码": "Heslo",
    "邀请码": "Pozvánkový kód",
    "确认密码": "Potvrďte heslo",
    "手机": "Mobilní telefon",
    "注册2": "Zaregistrovat se",
    "金额": "Částka",
    "新增": "Nový",
    "我们的精彩": "Naše úžasné",
    "故事": "Příběh",
    "奖项": "Ocenění",
    "获得": "Získané",
    "钱包余额": "Zůstatek peněženky",
    "累计佣金": "Kumulovaná provize",
    "今日奖励": "Dnešní odměny",
    "总行程": "Celková cesta",
    "访问行程": "Navštívené cesty",
    "酒店历史": "Podrobnosti objednávky",
    "单价": "Cena",
    "数量": "Počet",
    "总额": "Celkem",
    "奖励": "Odměny",
    "上一页": "Předchozí",
    "下一页": "Další",
    "每套预订量": "Rezervace na sadu",
    "预订奖励": "Odměna za rezervaci",
    "每日预订": "Denní rezervace",
    "手机号码": "Telefonní číslo",
    "修改密码": "Změnit heslo",
    "登录密码": "Heslo pro přihlášení",
    "当前密码": "Aktuální heslo",
    "新密码": "Nové heslo",
    "确认新密码": "Potvrďte nové heslo",
    "保存修改": "Uložit změny",
    "充值": "Dobít",
    "我们的": "Naše",
    "复制": "Kopírovat",
    "分享链接": "Sdílet odkaz",
    "搜索酒店": "Rezervovat cestu",
    "实际等级": "Skutečná úroveň",
    "升级": "Upgrade",
    "已完成预订": "Dokončené rezervace",
    "登录时间": "Čas přihlášení",
    "信誉分": "Důvěryhodnost",
    "控制菜单": "Ovládací menu",
    "提现": "Výběr",
    "提现账号": "Účet pro výběr",
    "你确定要删除此账号吗": "Opravdu chcete smazat tento účet?",
    "你确定要删除此地址吗": "Opravdu chcete smazat tuto adresu?",
    "提示": "Tipy",
    "是": "Ano",
    "否": "Ne",
    "全部": "Vše",
    "待处理": "Čeká na zpracování",
    "冻结中": "Zamrzlý",
    "已完成": "Dokončeno",
    "订阅": "Odebírat",
    "希望在我们推出新模板或更新时收到通知。 只需注册，我们就会通过电子邮件向您发送通知。": "Chcete být informováni, když spustíme novou šablonu nebo aktualizaci? Stačí se zaregistrovat a my vám pošleme oznámení e-mailem.",
    "我们的伙伴": "Naši partneři",
    "关于我们": "O NÁS",
    "实时聊天支持": "Podpora živého chatu",
    "在线聊天": "Živý chat",
    "创建时间": "Čas vytvoření",
    "你确定要登出当前账号吗？": "Opravdu chcete odhlásit aktuální účet?",
    "请输入你的邮箱": "Zadejte svůj e-mail",
    "好评": "Velmi dobré",
    "条评论": "Recenze",
    "平均每晚": "Průměr/noc",
    "旅行旅程": "Cestovní cesty",
    "正在寻找酒店": "Hledám cestu",
    "开始预订": "Začít rezervaci",
    "旅程价格": "Cena cesty",
    "佣金": "Provize",
    "底部-about": "Jsme digitální marketingová agentura se sídlem v Kalifornii, USA, která umožňuje firmám uspět v digitálním světě prostřednictvím inovativních a daty řízených marketingových strategií, personalizovaných služeb a růstového myšlení, které sleduje trendy v odvětví. Ať už potřebujete SEO agenturu, designéra webových stránek, správu placené reklamy, strategii značky, vývoj obsahu nebo jiné digitální marketingové služby, Tours4fun má odborné znalosti a zkušenosti, které vám pomohou dosáhnout vašich cílů ve světě zaměřeném na výsledky.",
    "立即预订": "Rezervujte nyní",
    "搜索": "Hledat",
    "快乐的客户": "Šťastný klient",
    "快乐的酒店老板": "Šťastný majitel hotelu",
    "评论1": "Architektura na budovách.",
    "评论2": "Tohle je skvělé místo na procházku s úzkými uličkami a krásnou architekturou na budovách.",
    "评论3": "Krásné náměstí mezi pláží a Centrální třídou.",
    "评论4": "Velmi hezké budovy s zajímavou historií.",
    "评论5": "Spousta restaurací na výběr a velmi uvolněná atmosféra.",
    "评论6": "Krásná země s nádhernými pomerančovými sady a zvířaty.",
    "评论7": "Skvělé místo na víkendový útěk.",
    "评论8": "Zajímavé místo ......",
    "评论9": "Skvělé místo, kde si můžete sednout a pozorovat svět kolem.",
    "评论10": "Luxusní plážový klub, který je krásným poctou těm, kteří zemřeli ve válce.",
    "评论11": "Je tu tolik co vidět a je to skvělé místo na dovolenou a relaxaci!",
    "评论12": "Poprvé zde a bylo to velmi příjemné, příště se vrátím.",
    "评论13": "Byla to jiná zkušenost a cítila jsem se skvěle, místní byli velmi přátelští a zdvořilí!",
    "推荐计划1": "Uživatelé platformy mohou pozvat ostatní, aby se stali agenty platformy prostřednictvím referenčních kódů a stát se vaším podřízeným.",
    "推荐计划2": "Jako nadřízený můžete získat určité procento z zisku vašeho podřízeného, a zisk získaný nadřízeným bude přímo vrácen na účet platformy nadřízeného, nebo do týmové zprávy.",
    "推荐计划3": "Poznámka: Všichni agenti / podřízení platformy obdrží určité procento zisků a odměn platformy, rozvoj týmu neovlivňuje zisky a odměny žádného agenta nebo podřízených.",
    "评分": "Hodnocení",
    "评论": "Komentář",
    "酒店很棒": "Hotel je skvělý",
    "终于体验了，酒店非常好": "Konečně jsem to zažil, hotel je velmi dobrý",
    "我对酒店非常满意并推荐预订": "Jsem velmi spokojen s hotelem a doporučuji rezervaci",
    "我很高兴很满意，价格实惠": "Jsem velmi šťastný a spokojený, cena je přijatelná",
    "服务非常好，我非常喜欢": "Služba je velmi dobrá, velmi se mi líbí",
    "体验很不错，朋友已经第二次预订了": "Zážitek byl velmi dobrý, můj přítel již rezervoval podruhé",
    "酒店环境优美": "Krásné prostředí hotelu",
    "酒店卫生干净": "Hotel je hygienický a čistý",
    "工作人员态度非常好": "Postoj personálu je velmi dobrý",
    "酒店服务很棒": "Služba hotelu je skvělá",
    "你还没有设置支付密码，请前往设置": "Nastavili jste platební heslo, prosím přejděte do nastavení",
    "订单": "Objednávky",
    "复制成功": "Kopírování úspěšné",
    "团队与条件": "Podmínky a ujednání",
    "站内信": "Zprávy na webu",
    "请联系客服升级会员": "Kontaktujte prosím zákaznický servis pro upgrade členství",
    "我已阅读并同意": "Přečetl jsem si a souhlasím s",
    "注册协议": "Registrační dohoda",
    "忘记密码": "Zapomenuté heslo",
    "账户明细": "Podrobnosti o účtu",
    "时间": "Čas",
    "类型": "Typ",
    "代理支持": "Podpora agentů",
    "冻结金额": "Zamrzlá částka",

    "点击下面的金蛋抽取奖励": "Klikněte na zlaté vejce níže a vyhrajte cenu",
    "恭喜您中奖了！": "Gratulujeme k výhře!",
    "很遗憾，您没有中奖": "Bohužel jste nevyhráli",
    "公告": "Oznámení",
}